module.exports = __webpack_public_path__ + "static/media/map-baner-bg.550d89db.svg";